import type { ButtonHTMLAttributes, ReactNode } from 'react';

import './Button.styl';

/**
 * `add`: create/add actions (green, white plus-circle). `accent`: edit, approvals, reports and navigation (orange with
 * white text). Colours chosen by the user.
 */
export type ButtonVariant = 'primary' | 'ghost' | 'dark' | 'danger' | 'link' | 'soft' | 'cancel' | 'add' | 'accent';
export type ButtonSize = 'sm' | 'md';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant;
  size?: ButtonSize;
  loading?: boolean;
  iconLeft?: ReactNode;
  block?: boolean;
};

export function Button({
  variant = 'primary',
  size = 'md',
  loading = false,
  iconLeft,
  block = false,
  className,
  children,
  disabled,
  type = 'button',
  ...rest
}: Props) {
  const classes = ['a-btn', `a-btn--${variant}`, `a-btn--${size}`];
  if (block) classes.push('a-btn--block');
  if (className) classes.push(className);
  return (
    <button
      type={type}
      className={classes.join(' ')}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {iconLeft ? <span className="a-btn__icon">{iconLeft}</span> : null}
      <span className="a-btn__label">{children}</span>
    </button>
  );
}
